import './BeianFooter.css'

/** 全局备案号页脚：固定在页面底部，低调灰色小字 */
export default function BeianFooter() {
  return (
    <footer className="beian-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        冀ICP备2025103215号-2
      </a>
    </footer>
  )
}
